import {
  Box,
  Button,
  Input,
  Select,
  Text,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import * as React from "react";
import { api } from "../../config";
import { useQuery } from "@tanstack/react-query";

const ImportStudents: React.FC = () => {
  const [file, setFile] = React.useState<File | null>(null);
  const [groupId, setGroupId] = React.useState<number | null>(null);
  const toast = useToast();

  // ✅ Fetch classes (same as your ViewGroups logic)
  const fetchGroups = async () => {
    const { data } = await axios.get(`${api}/groups`, {
      withCredentials: true,
    });
    return data;
  };

  const { data: groups, isLoading } = useQuery(
    ["groups-dropdown"],
    fetchGroups
  );

  const handleUpload = async () => {
    try {
      if (!file || !groupId) {
        throw new Error("Please select a CSV file and class");
      }

      const confirm = window.confirm(
        `Are you sure you want to import students to selected class?`
      );
      if (!confirm) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("groupId", String(groupId));

      const res = await axios.post(
        `${api}/announcements/import-students`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast({
        title: "✅ Students imported successfully",
        status: "success",
        position: "bottom-right",
      });
    } catch (error: any) {
      toast({
        title: error.message || "Upload failed",
        status: "error",
        position: "bottom-right",
      });
    }
  };

  return (
    <Box p="6">
      <Text fontSize="xl" mb="4">
        Import Students via CSV
      </Text>

      {/* File Upload */}
      <Input
        type="file"
        accept=".csv"
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
          }
        }}
        mb="3"
      />

      {/* Class Select (Dynamic) */}
      {isLoading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select Class"
          onChange={(e) => setGroupId(Number(e.target.value))}
          mb="3"
        >
          {groups?.map((group: any) => (
            <option key={group.id} value={group.id}>
              {group.groupName}
            </option>
          ))}
        </Select>
      )}

      <Button colorScheme="blue" onClick={handleUpload}>
        Upload & Import
      </Button>
    </Box>
  );
};

export default ImportStudents;